<div class='country-selector-container'>
    <app-input-field (valueSelected)='setCountry()'  [parentForm]='getCountrySelectionForm()' [inputJson]='getCountryFieldObject()'>
    </app-input-field>
</div>